module.exports = __webpack_public_path__ + "static/media/power-lightning.9ebddabb.svg";